/**
 * src/hooks/useProspeccion.js
 * React Query v5 hooks del módulo de prospección.
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  ejecutarProspeccion, getProspeccionLeads, getProspeccionStatus, importarProspeccion,
} from '../api/prospeccion'

export function useProspeccionStatus() {
  return useQuery({
    queryKey: ['prospeccion', 'status'],
    queryFn: getProspeccionStatus,
    // Un run avanza proveedor a proveedor: refresco corto para ver el avance.
    refetchInterval: 30_000,
  })
}

export function useProspeccionLeads(params) {
  return useQuery({
    queryKey: ['prospeccion', 'leads', params],
    queryFn: () => getProspeccionLeads(params),
    refetchInterval: 60_000,
  })
}

export function useEjecutarProspeccion() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ejecutarProspeccion,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['prospeccion'] }),
  })
}

export function useImportarProspeccion() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: importarProspeccion,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['prospeccion'] }),
  })
}
